import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";
import { AvatarStack, IllustrativeTag, StatusBadge } from "@/components/common";
import { CardNumbers } from "@/components/experience/Numbers";
import { coverOf, formatDates } from "@/lib/api";
import { CardVideo } from "@/components/experience/CardVideo";
import { cn } from "@/lib/utils";

export const ExperienceCard = ({ exp, onToggleSave, index = 0 }) => (
  <article data-testid={`experience-card-${exp.id}`} className="surface card-hover fade-up group relative flex flex-col overflow-hidden" style={{ animationDelay: `${Math.min(index, 8) * 70}ms` }}>
    <Link to={`/experiences/${exp.id}`} tabIndex={-1} aria-hidden className="relative block aspect-[16/10] overflow-hidden" data-testid={`card-image-link-${exp.id}`}>
      <img src={coverOf(exp)} alt="" className="img-cover" loading="lazy" />
      {exp.video && <CardVideo path={exp.video} id={exp.id} />}
    </Link>
    <div className="pointer-events-none absolute inset-x-0 top-0 flex items-start justify-between p-3">
        {exp.is_sample ? <IllustrativeTag /> : <span />}
        {onToggleSave && (
          <button type="button" onClick={() => onToggleSave(exp.id)} aria-label={exp.saved ? "Remove from saved" : "Save experience"} aria-pressed={exp.saved}
            data-testid={`save-experience-${exp.id}`} className="pointer-events-auto flex h-11 w-11 items-center justify-center rounded-full bg-background/40 backdrop-blur transition-colors hover:bg-background/70">
            <Heart className={cn("h-5 w-5", exp.saved ? "fill-primary text-primary" : "text-foreground")} />
          </button>
        )}
    </div>
    <div className="flex flex-1 flex-col gap-4 p-5 sm:p-6">
      <div>
        <h3 className="font-display text-[26px] leading-tight sm:text-[30px]"><Link to={`/experiences/${exp.id}`} className="hover:text-primary" data-testid={`card-title-link-${exp.id}`}>{exp.title}</Link></h3>
        <p className="mt-1 text-muted-foreground">{exp.destination} <span aria-hidden>·</span> {formatDates(exp)}</p>
      </div>
      {!exp.is_sample && <CardNumbers exp={exp} />}
      <div className="flex flex-wrap items-center gap-4">
        {exp.circle_preview?.length > 0 && <AvatarStack people={exp.circle_preview} />}
        <StatusBadge status={exp.status} />
      </div>
      <Link to={`/experiences/${exp.id}`} className="btn-link mt-auto self-start" data-testid={`view-plan-${exp.id}`}>
        View plan <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  </article>
);
